import { createSlice } from "@reduxjs/toolkit";



export const periodDatesSlice = createSlice({ //reducers for 2 dates in global state
    name: 'dates',
    initialState:{},
    reducers: {
        setDate: (currentState, action) => {
            
            if (action.payload.index===1){ //which date do we have to update? start or return?
                return [action.payload.jour,currentState[1]] //update start date, keep return date
            }
            else{
                return [currentState[0],action.payload.jour]; //update return date, keep start date
            }

        }
    }
});

export const periodHeuresSlice = createSlice({ //reducers for both hours in global state
    name: 'heures',
    initialState:{},
    reducers: {
        setHeure: (currentState, action) => {
            if (action.payload.index===1){ //which hour do we have to update? start or return?
                return [action.payload.heure,currentState[1]] //update start hour, keep return hour
            }
            else{
                return [currentState[0],action.payload.heure]; //update return hour, keep start hour
            }

        }
    }
});

